import React from 'react';
import PropTypes from 'prop-types';
import {useMemoizedProposedValue} from "../helpers";
import KeySection from "../components/KeySection";
import AddAccordionItem from "../components/AddAccordionItem";
import {useCurrentValue} from "../components/useCurrentValue";
import {displayOnlyPropertiesFor, hiddenPropertiesFor, predefinedOptionPropertiesFor} from "./commonFunctions";

const BillingAddressAdd = ({billingAddressAdded, billingAddressIndex}) => {
    const billingAddressKey = "addedBillingAddresses[" + billingAddressIndex + "]"
    const npi = useMemoizedProposedValue(billingAddressAdded.keys, "NPI");
    const tin = useMemoizedProposedValue(billingAddressAdded.keys, "TIN");
    const lineOfService = useMemoizedProposedValue(billingAddressAdded.keys, "Line of Service");
    const effectiveDate = useMemoizedProposedValue(billingAddressAdded.keys, "Effective Date");
    
    const hiddenProperties = hiddenPropertiesFor();
    const displayOnlyProperties = displayOnlyPropertiesFor();
    const predefinedOptionsProperties = predefinedOptionPropertiesFor()
    return (
        <AddAccordionItem properties={billingAddressAdded.properties}
                          header={"NPI " + npi + ", TIN " + tin + ", Line of Service " + lineOfService}
                          controlId={billingAddressKey}
                          index={billingAddressIndex}
                          effectiveDate={effectiveDate}
                          hiddenPropertyNames={hiddenProperties}
                          displayOnlyPropertyNames={displayOnlyProperties}
                          predefinedOptionProperties={predefinedOptionsProperties}
        >
            <KeySection keys={billingAddressAdded.keys}
                        tooltip={"The keys are used to identify unique remittance addresses in the file"}>
            </KeySection>
        </AddAccordionItem>
    )
}
BillingAddressAdd.propTypes = {
    billingAddressAdded: PropTypes.object.isRequired,
    billingAddressIndex: PropTypes.number.isRequired
}
export default BillingAddressAdd